module.exports = __webpack_public_path__ + "media/images/badges/kinrgy/Kinrgy-10-Classes-Inactive-5c2da002d29bc7688c012c09d3862119.png";